import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import UserDashboard from './pages/user/UserDashboard';
import Courses from './pages/user/courses/Courses';
import Support from './pages/support/index';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AnalyticReport from './pages/user/courses/analyticsreportgroupuser/AnalyticReport';
import UserAnalyticReport from './pages/user/userAnalytic/UserAnalyticReport';
// import UserAnalytic from './pages/user/userAnalytic/UserAnalytic';
// import GroupAnalytic from './pages/user/userAnalytic/groupreport/GroupReport';
import KPI from './pages/Admin/Kpi/kpi';
import Certificates from './pages/Admin/Certificates/Certificate';
import EditCriteria from './pages/Admin/EditCriteria';
import TotalTrainings from './pages/Admin/totaltrainings';
import ExploreCourse from './pages/ExploreCourses';
import ModuleDetails from './pages/moduleplay/ModuleDetails';
import Home from './pages/BeforeLoginPages/Home/Home';
import About from './pages/BeforeLoginPages/About/About';
import ContactUs from './pages/BeforeLoginPages/Contact/ContactUs';
import Reports from './pages/Admin/Reports/Reports'
import TimesPlayedDetailed from './pages/user/userAnalytic/groupreport/TimesPlayedDetailed';
import QuizDetailedView from './pages/user/userAnalytic/groupreport/QuizDetailedView';
import ConfigurationPage from './pages/ConfigPage/configurationPage';
import LMSUserDashboard from './pages/LMS/LMSUserDashboard';
import LMSTeamDashboard from './pages/LMS/LMSTeamDashboard';

export default function AppRouter({ redirectUri , userPlan }) {
  const navigate = useNavigate();
  const userData = useSelector(state => state.userSlice);
  const configData = useSelector(state => state.configSlice);
  let MODE = configData.config.MODE
  const isLoggedIn = userData.token ? true : false;

  let defaultRoute;


  if (isLoggedIn) {
    MODE == "2D" ?
      defaultRoute = `/2d/lms/dashboard/${userData.user.uuid}`
       :
      defaultRoute = `/dashboard/${userData.user.uuid}`
  }
  else if (configData.visibleSections.includes('explore')) {
      defaultRoute = '/explore';
  } else if (configData.visibleSections.includes('home')) {
      defaultRoute = '/home';
  } else if (configData.visibleSections.includes('aboutUs')) {
      defaultRoute = '/about-us';
  } else if (configData.visibleSections.includes('contactUs')) {
      defaultRoute = '/contact';
  }

  
  useEffect(() => {
    if (redirectUri) {
      if (redirectUri === "/" && MODE === "2D") {
        navigate(`/2d/lms/dashboard/${userData.user.uuid}`);
      } else {
        navigate(redirectUri === "/" ? `/dashboard/${userData.user.uuid}` : redirectUri);
      }
    }
  }, []);


  return (
    <Routes>

      {isLoggedIn &&
        <>
          {userData.user.permissions.includes("XR.DASHBOARD.OWN") && <Route path='/dashboard/:uuid' element={<UserDashboard userPlan={userPlan} />} />}
          {userData.user.permissions.includes(`XR.DASHBOARD.TEAM`) && <Route path='/team/user/:uuid' element={<UserDashboard />} />}
          {userData.user.permissions.includes(`XR.DASHBOARD.TEAM`) && userData.plans?.data?.teamDashboard?.access && <Route path='/team-dashboard/:groupId' element={<AdminDashboard />} />}
          {/* {userData.user.permissions.includes("XR.DASHBOARD.COURSES") && <Route path='/courses' element={<Courses />} />} */}
          {["XR.DASHBOARD.COURSES", "SKILL.STREAM.COURSES"].some(permission => userData.user.permissions.includes(permission)) && <Route path='/courses' element={<Courses />} />}
          {userData.user.permissions.includes('XR.DASHBOARD.KPI') && userData.plans?.data?.kpi?.access && <Route path='/kpi' element={<KPI />} />}
          {userData.user.permissions.includes("XR.PASSINGCRITERIA.UPDATE") && <Route path='/set/passing/criteria/:id' element={<EditCriteria/>} />}
          {userData.user.permissions.includes('XR.DASHBOARD.ANALYTICS') && <Route path='/module/group/user/played/:groupId/:resourceId' element={<TimesPlayedDetailed/>} />}
          {userData.user.permissions.includes('XR.DASHBOARD.ANALYTICS') && <Route path='/module/report/group/attempted/quiz/:groupId/:resourceId' element={<QuizDetailedView/>} />}
          {userData.user.permissions.includes('XR.DASHBOARD.ANALYTICS') && <Route path='/module/report/group/:groupId/:uuid' element={<AnalyticReport />} />}
          {userData.user.permissions.includes('XR.DASHBOARD.ANALYTICS') && <Route path='/module/report/user/:uuid' element={<UserAnalyticReport />} />}
          {/* {userData.user.permissions.includes('XR.DASHBOARD.ANALYTICS') && <Route path='/user-report' element={<UserAnalytic />} />} */}
          {/* {userData.user.permissions.includes('XR.DASHBOARD.ANALYTICS') && <Route path='/group-report' element={<GroupAnalytic />} />} */}
          {userData.user.permissions.includes('XR.DASHBOARD.ANALYTICS') && <Route path='/total-trainings-list/:groupId' element={<TotalTrainings />} />}
          {["XR.CERTIFICATES.LIST", "SKILL.STREAM.CERTIFICATES.LIST"].some(permission => userData.user.permissions.includes(permission)) && <Route path='/certificates/:userUUID' element={<Certificates />} />}
          { userData.plans?.data?.report?.access && <Route path='/reports/:groupId' element={<Reports/>} /> }
          <Route path='/support' element={<Support />} />
          {["XR.CONFIGURATION", "SKILL.STREAM.CONFIGURATION"].some(permission => userData.user.permissions.includes(permission)) && <Route path='/update/configuration/:id' element={<ConfigurationPage />} />}
          
          
          {userData.user.permissions.includes("SKILL.STREAM.DASHBOARD.OWN") && <Route path='/2d/lms/dashboard/:uuid' element={<LMSUserDashboard />} />}
          {userData.user.permissions.includes("SKILL.STREAM.DASHBOARD.TEAM") && <Route path='/2d/lms/team/user/:uuid' element={<LMSUserDashboard />} />}
          {userData.user.permissions.includes("SKILL.STREAM.DASHBOARD.TEAM") && <Route path='/2d/lms/team-dashboard/:groupId' element={<LMSTeamDashboard />} />}
          
        </>
      }

      {configData.visibleSections.includes('home') && <Route path='/home' element={<Home />} />}
      {configData.visibleSections.includes('aboutUs') && <Route path='/about-us' element={<About />} />}
      {configData.visibleSections.includes('explore') && <Route path='/explore' element={<ExploreCourse />} />}
      {configData.visibleSections.includes('contactUs') && <Route path='/contact' element={<ContactUs />} />}
      
      {/* {MODE === "XR" && userData.user.permissions.includes("XR.DASHBOARD.PLAYCOURSE") && <Route path='/course/details/:uuid' element={<ModuleDetails />} /> } */}
      {MODE === "XR" && <Route path='/course/details/:uuid' element={<ModuleDetails />} /> }
      {MODE === "2D" && <Route path='/course/details/:uuid' element={<ModuleDetails />} />}

      <Route path='*' element={<Navigate to={defaultRoute} state={userData.user} />} />

    </Routes>

  )
}
